/*
 * Bringing the assistant to the page.
 *
 * window.AtomzChat is assigned by az-chat-sdk.js, and NOTHING on a page loads
 * that file by itself. The chat tile did, which is why the assistant worked on
 * search and collection pages and only there. Everything else -- the band, the
 * sold-out panel, the objection blocks -- waited for a global that was never
 * coming, gave up, and took its own button away. The homepage band shipped
 * with no button at all for exactly this reason.
 *
 * So the loading lives here, once, and anything that offers the assistant asks
 * for it:
 *
 *   window.AtomzChatBoot.ready().then(function (chat) { ... })
 *
 * The promise is made once per page and handed to every later caller, so five
 * blocks on one page fetch one script between them.
 *
 * THE URL IS READ OFF THE PAGE, not hard-coded: the extension URL carries a
 * version that changes on every release of the app. The search bar block sits
 * in the header group on every page, so there is always a script tag to read
 * it from. No tag means the app is not installed on this theme, and that
 * rejects immediately rather than after a wait -- a caller that is going to
 * hide its own button should hide it now, not in nine seconds.
 */
(function () {
  'use strict';

  var SDK = 'az-chat-sdk.js';
  var CSS = 'az-chat.css';

  /*
   * The ceiling is on the SDK's own evaluation, which begins only once the
   * file has arrived. It is generous because the alternative -- a button that
   * disappears from under a slow connection -- is worse than one that appears
   * late.
   */
  var WAIT_MS = 15000;
  var POLL_MS = 100;

  var pending = null;

  function extensionBase() {
    var tags = document.querySelectorAll('script[src*="atomz-ai-search-prompts"]');
    for (var i = 0; i < tags.length; i++) {
      var src = tags[i].getAttribute('src') || '';
      var cut = src.lastIndexOf('/');
      if (cut > 0) return src.slice(0, cut + 1);
    }
    return null;
  }

  function loadOnce(url, isCss) {
    var sel = isCss ? 'link[href="' + url + '"]' : 'script[src="' + url + '"]';
    if (document.querySelector(sel)) return;
    var el;
    if (isCss) {
      el = document.createElement('link');
      el.rel = 'stylesheet';
      el.href = url;
    } else {
      el = document.createElement('script');
      el.src = url;
      el.defer = true;
    }
    document.head.appendChild(el);
  }

  function ready() {
    if (window.AtomzChat) return Promise.resolve(window.AtomzChat);
    if (pending) return pending;

    pending = new Promise(function (resolve, reject) {
      var base = extensionBase();
      if (!base) return reject(new Error('no atomz script on the page'));

      loadOnce(base + CSS, true);
      loadOnce(base + SDK, false);

      /*
       * The SDK assigns the global at the end of its own evaluation and fires
       * no event, so poll rather than race it. A load handler on the script
       * tag is not enough: the tag can be one another caller already added,
       * in which case the event has been and gone.
       */
      var waited = 0;
      var tick = setInterval(function () {
        if (window.AtomzChat) {
          clearInterval(tick);
          resolve(window.AtomzChat);
        } else if ((waited += POLL_MS) > WAIT_MS) {
          clearInterval(tick);
          reject(new Error('AtomzChat did not arrive'));
        }
      }, POLL_MS);
    });

    /* A rejection is asked again on the next call rather than cached forever:
     * a block added by the theme editor after the app block loads should not
     * inherit a failure that happened before it existed. */
    pending.catch(function () { pending = null; });

    return pending;
  }

  window.AtomzChatBoot = { ready: ready };
})();
